import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TopNav from "../layouts/TopNav";
import { BsArrowLeft } from "react-icons/bs";
import { AiOutlinePrinter } from "react-icons/ai";
import "../Styles/approve.css";
import html2pdf from "html2pdf.js";
import AcceptRequisition from "../components/AcceptRequisition";
import RejectRequisition from "../components/RejectRequisition";

const AcceptApprove = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const requisitionDetails = location.state;

  const [approveModal, setAccProveModal] = useState(false);
  const [details, setDetails] = useState(requisitionDetails);

  useEffect(() => {
    if (!requisitionDetails) {
      // If requisitionDetails is null, redirect back to the previous page or a safe fallback
      navigate("/dashboard/approval");
    }
  }, [requisitionDetails, navigate]);

  const handleApproveModal = () => {
    setAccProveModal(!approveModal);
  };

  const [rejectModal, setRejectModal] = useState(false);
  const handleRejectModal = () => {
    setRejectModal(!rejectModal);
  };

  const generatePDF = () => {
    const slipElement = document.querySelector(".combo");
    if (slipElement) {
      const pdfOptions = {
        margin: 2,
        filename: "approve.pdf",
        image: { type: "png" },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
      };
      html2pdf().from(slipElement).set(pdfOptions).save();
    }
  };

  const handleRefund = () => {
    if (requisitionDetails && requisitionDetails._id) {
      navigate("/dashboard/requirefund", {
        state: {
          requisitionId: requisitionDetails._id,
          items: requisitionDetails.items,
        },
      });
    }
  };

  if (!requisitionDetails) {
    // Render a loading state or a message indicating the data is missing
    return <div>Loading...</div>;
  }

  return (
    <div className="board">
      <TopNav title="Approve" />
      <div className="line"></div>
      <BsArrowLeft
        style={{
          cursor: "pointer",
          fontSize: "30px",
          marginLeft: "2em",
          marginTop: "1em",
        }}
        onClick={() => navigate("/dashboard/approval")}
      />
      <div className="combo">
        <div className="apRequi">
          <div className="RequiName">
            <h2>AP</h2>
            <div className="reName">
              <p>{requisitionDetails.customer?.businessName}</p>
              <span>Lagos Nigeria</span>
            </div>
          </div>
          <div className="RequiNum">
            <p>Requisition Number: {requisitionDetails.requisitionRef}</p>
            <p>Requisition Status: {requisitionDetails.status}</p>
          </div>
        </div>
        <div className="line"></div>
        <div className="reApprove">
          <div>
            <div className="input">
              <label>Customer Name</label>
              <input
                type="text"
                value={requisitionDetails.customer?.businessName}
                readOnly
              />
            </div>
            <div className="input">
              <label>Requisition Time</label>
              <input
                type="text"
                value={requisitionDetails.requisitionTime}
                readOnly
              />
            </div>
            <div className="input">
              <label>Payment Type</label>
              <input
                type="text"
                value={requisitionDetails.paymentTerms}
                readOnly
              />
            </div>
            <div className="input">
              <label>Bridging</label>
              <input type="text" value={requisitionDetails.bridging} readOnly />
            </div>
            <div className="input">
              <label>Selected Product</label>
              <input
                type="text"
                value={requisitionDetails.items
                  .map((pro: any) => pro.name)
                  .join(", ")}
                readOnly
              />
            </div>
          </div>
          <div>
            <div className="input">
              <label>Business Type</label>
              <input
                type="text"
                value={requisitionDetails.businessType}
                readOnly
              />
            </div>
            <div className="input">
              <label>Payment Type</label>
              <input
                type="text"
                value={requisitionDetails.paymentTerms}
                readOnly
              />
            </div>
            <div className="input">
              <label>MVT Type</label>
              <input type="text" value={requisitionDetails.mvtType} readOnly />
            </div>
            <div className="input">
              <label>Quantity</label>
              <input
                type="text"
                value={requisitionDetails.items
                  .map((pro: any) => pro.quantity)
                  .join(", ")}
                readOnly
              />
            </div>
            <div className="input">
              <label>Unit Price</label>
              <input
                type="text"
                value={requisitionDetails.items
                  .map((pro: any) => pro.unitPrice)
                  .join(", ")}
                readOnly
              />
            </div>
          </div>
        </div>
      </div>
      <div className="accBtm">
        {requisitionDetails.status !== "APPROVED" ? (
          <div className="actBtn">
            <button className="actB approveBtn" onClick={handleApproveModal}>
              Approve
            </button>
            <button className="actB rejectBtn" onClick={handleRejectModal}>
              Reject
            </button>
          </div>
        ) : null}
        <div className="can">
          {requisitionDetails.status === "APPROVED" && (
            <>
              <span onClick={generatePDF}>
                Print <AiOutlinePrinter />
              </span>
              <span
                onClick={handleRefund}
                style={{ marginLeft: "10px", cursor: "pointer" }}
              >
                Refund
              </span>
              <button className="actB rejectBtn" onClick={handleRejectModal}>
              Reject
            </button>
            </>
          )}
        </div>
        {approveModal ? (
          <AcceptRequisition
            handleApproveModal={handleApproveModal}
            setAccProveModal={setAccProveModal}
            details={details}
          />
        ) : null}
        {rejectModal ? (
          <RejectRequisition
            details={details}
            handleRejectModal={handleRejectModal}
            setRejectModal={setRejectModal}
          />
        ) : null}
      </div>
    </div>
  );
};

export default AcceptApprove;
